export type HealthCheckStatusKey = 'RED' | 'YELLOW' | 'GREEN' | 'GREY';

export interface HealthCheckKpi {
  status: number;
  statusText: HealthCheckStatusKey;
  name: string;
}

export type HealthCheckCount = Record<HealthCheckStatusKey, number>;

export const HEALTH_CHECK_STATUS = {
  GREEN: 0,
  YELLOW: 1,
  RED: 2,
  GREY: 3,
} as const;
